import React from 'react';
import { List, Grid, Header, Icon, Container } from 'semantic-ui-react';
import { StyledSegment, RutubeIconCover, IconCover, Circle, PhoneNumber } from './style';
import { RutubeIcon } from './RutubeIcon';
export var Footer = function (_a) {
    var currentAct = _a.currentAct;
    var isOlympEn = currentAct === 'olymp_en', isOlymp = currentAct === 'olymp';
    var contacts;
    if (isOlympEn) {
        contacts = (React.createElement(React.Fragment, null,
            React.createElement(List.Item, null,
                "tel.: ",
                React.createElement(PhoneNumber, { href: "tel:+78362422468" }, "+7 (8362) 42-24-68")),
            React.createElement(List.Item, null,
                "email: ",
                React.createElement("a", { href: "mailto:nii.mko@yandex.ru" }, "nii.mko@yandex.ru"))));
    }
    else {
        contacts = (React.createElement(React.Fragment, null,
            React.createElement(List.Item, null,
                "\u0442\u0435\u043B.: ",
                React.createElement(PhoneNumber, { href: "tel:+78362422468" }, "+7 (8362) 42-24-68")),
            React.createElement(List.Item, null,
                "email: ",
                React.createElement("a", { href: "mailto:nii.mko@yandex.ru" }, "nii.mko@yandex.ru"))));
    }
    return (React.createElement(StyledSegment, { inverted: true, vertical: true },
        React.createElement(Container, null,
            React.createElement(Grid, { inverted: true, stackable: true, columns: 'equal' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { as: 'h4', inverted: true }, isOlympEn ? 'Contacts' : 'Контактная информация'),
                        React.createElement(List, { inverted: true }, contacts)),
                    !isOlympEn && React.createElement(Grid.Column, { width: 5 },
                        React.createElement(List, { inverted: true },
                            React.createElement(List.Item, null,
                                React.createElement(IconCover, { href: "//vk.com/niimko", target: "_blank" },
                                    React.createElement(Circle, null,
                                        React.createElement(Icon, { name: 'vk' })),
                                    "vk.com/niimko")),
                            isOlymp ?
                                React.createElement(List.Item, null,
                                    React.createElement(IconCover, { href: "//vk.com/iolymps_club", target: "_blank" },
                                        React.createElement(Circle, null,
                                            React.createElement(Icon, { name: 'vk' })),
                                        "vk.com/iolymps_club"))
                                :
                                    React.createElement(List.Item, null,
                                        React.createElement(IconCover, { href: "//vk.com/fieb_for_you", target: "_blank" },
                                            React.createElement(Circle, null,
                                                React.createElement(Icon, { name: 'vk' })),
                                            "vk.com/fieb_for_you")),
                            React.createElement(List.Item, null,
                                React.createElement(IconCover, { href: "https://t.me/i_exam", target: "_blank" },
                                    React.createElement(Circle, null,
                                        React.createElement(Icon, { name: 'telegram plane' })),
                                    "t.me/i_exam")),
                            React.createElement(List.Item, null,
                                React.createElement(RutubeIconCover, { href: "https://rutube.ru/channel/28032892/", target: "_blank" },
                                    React.createElement(Circle, null,
                                        React.createElement(RutubeIcon, null)),
                                    "i-exam.ru"))))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement("p", null,
                            "\u00A9 2002-",
                            (new Date()).getFullYear(),
                            isOlympEn ? ' Research Institute for Education Quality Monitoring.' : ' НИИ мониторинга качества образования.'),
                        !isOlympEn && React.createElement("p", null, "\u041F\u0440\u0438 \u0446\u0438\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0441 \u0441\u0430\u0439\u0442\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 i-exam.ru \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u0430")))))));
};
//# sourceMappingURL=Footer.js.map